<template>
  <grid-container-fi
    class="smart-recruiters-detail__section smart-recruiters-detail__section-three"
  >
    <headline-fi
      class="smart-recruiters-detail__section-three-headline"
      :set-border="true"
      :size="36"
      tag="h3"
      color="brand"
    >
      {{ fields.headlineBenefits?.value }}
    </headline-fi>
    <div
      v-for="item in benefits"
      :key="item.title"
      class="smart-recruiters-detail__benefits-list"
    >
      <icon-fi
        :icon="iconName(item.icon)"
        :style="!item.icon ? 'opacity: 0' : null"
        class="smart-recruiters-detail__benefits-icon"
      />
      <div class="smart-recruiters-detail__benefits-text">
        <div class="smart-recruiters-detail__benefits-title">
          {{ item.title }}
        </div>
        <div
          v-if="item.subTitle"
          class="smart-recruiters-detail__benefits-sub-title"
        >
          {{ item.subTitle }}
        </div>
      </div>
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import { HeadlineFi, IconFi } from 'atoms';
import { computed } from 'vue';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFields } from '@/composables/fields';

import {
  packEightId,
  packElevenId,
  packFiveId,
  packFourId,
  packNineId,
  packOneId,
  packSevenId,
  packSixId,
  packTenId,
  packThirteenId,
  packThreeId,
  packTwelveId,
  packTwoId,
} from '../CustomFields';

defineOptions({ name: 'SmartRecruitersDetailSectionThree' });

const props = defineProps<{
  benefitsPackageId: string;
  isIframe?: boolean;
}>();

const fields = useFields('SmartRecruitersDetailPageFields');

const benefits = computed(() => {
  if (!props.benefitsPackageId) {
    return [];
  }

  const packs: Record<string, string> = {
    [packOneId]: 'One',
    [packTwoId]: 'Two',
    [packThreeId]: 'Three',
    [packFourId]: 'Four',
    [packFiveId]: 'Five',
    [packSixId]: 'Six',
    [packSevenId]: 'Seven',
    [packEightId]: 'Eight',
    [packNineId]: 'Nine',
    [packTenId]: 'Ten',
    [packElevenId]: 'Eleven',
    [packTwelveId]: 'Twelve',
    [packThirteenId]: 'Thirteen',
  };
  const pack = packs[props.benefitsPackageId];
  if (!pack) {
    console.error(`Unknown pack id: '${props.benefitsPackageId}'`);
    return [];
  }
  const field = (fields as Record<string, any>)[`pack${pack}Benefits`];
  if (!field) {
    console.error('Missing benefits for pack', pack);
    return [];
  }

  return field.map(({ fields: itemFields }: any) => ({
    title: itemFields.title?.value,
    subTitle: itemFields.subTitle?.value,
    icon: itemFields.icon?.value?.src,
    fields: itemFields,
  }));
});

function iconName(src?: string) {
  if (!src) {
    return 'fischer-function';
  }

  const name = (src.toLocaleLowerCase().split('/').pop() ?? '')
    .replace(new RegExp('\\b\\.(svg|ashx)\\b', 'gi'), '')
    .split('?')[0];

  return name;
}
</script>

<style scoped src="./smart-recruiters-detail-section-three" />
